export const UPDATE_PENDENCY_SUMMARY = 'UPDATE_PENDENCY_SUMMARY';

export default function updatePendencySummary(newSummary) {
  return {
    type: UPDATE_PENDENCY_SUMMARY,
    payload: {
      ...newSummary,
    },
  };
}
